/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-10-05                        ||
//===============================================*/
import {Component, Injectable, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService} from 'primeng/primeng';
import {Location} from '@angular/common';
import {FormBuilder, FormGroup} from '@angular/forms';
import {EvsScanStampService} from '../../../../common/services/EvsScanStamp.service';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: "box_baohanh_form",
    templateUrl: './box_baohanh_form.component.html',
    styleUrls: ['./scan.css'],
    providers: [ConfirmationService]
})

@Injectable()
export class BoxBaoHanhFormComponent implements OnInit {
    public baoHanhForm: FormGroup;
    public baohanh: any = {};
    public message: { class: string, content: string } = null;

    constructor(private _location: Location,
                private router: Router,
                private scanService: EvsScanStampService,
                private activatedRoute: ActivatedRoute,
                private confirmationService: ConfirmationService,
                private _fb: FormBuilder) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add("animsition");   //add the class
        body.classList.add("layout-full");   //add the class
    }

    ngOnInit() {

    }

    submit(data) {
        this.message = null;
        let objectData = {};
        if (this.baohanh.fullname.trim().length === 0)
            this.message = {class: "alert alert-danger", content: "Họ tên không được bỏ trống"};
        if (!this.baohanh.phone)
            this.message = {class: "alert alert-danger", content: "Điện thoại không được bỏ trống"};
        else if (this.baohanh.address.trim().length === 0)
            this.message = {class: "alert alert-danger", content: "Địa chỉ không được bỏ trống"};
        else {
            objectData = {
                name: this.baohanh.fullname,
                country: this.baohanh.fullname,
                city: this.baohanh.fullname,
                address: this.baohanh.address,
                phone: this.baohanh.phone,
                district: this.baohanh.fullname,
                email: this.baohanh.email,
            };
            console.log("update bao hanh: ", objectData);
            this.scanService.updateBaoHanh(objectData).subscribe(res => {
                if (res) {
                    this.message = {
                        class: "alert dark alert-icon alert-success alert-dismissible",
                        content: "Cập nhật thành công"
                    };
                    data.resetForm();
                    this.scrollToMsg();
                }
            }, error => {
                this.message = {class: "alert dark alert-icon alert-danger alert-dismissible", content: error.message};
                this.scrollToMsg();
            });
        }
    }

    scrollToMsg() {
        var aTag = $("a[name='msg']");
        $('html,body').animate({scrollTop: aTag.offset().top}, 'slow');
    }

    backToComponent() {
        this._location.back();
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/scan/box_baohanh_form.component.ts